import type { AgentCard, RuntimeFilter, StatusFilter } from '../types';
import { cardStatus } from './agentStatus';

/** Every runtime the board can narrow by, in the order the picker shows them. */
export const RUNTIME_ORDER: Array<Exclude<RuntimeFilter, 'all'>> = [
  'claude',
  'hermes',
  'n8n',
  'cloud',
  'python',
  'bash',
  'external',
];

/**
 * The runtimes at least one card on the board carries. Offering a filter for a runtime nobody runs reads
 * as "there is work here you cannot see", so the picker follows what is actually there.
 */
export const availableRuntimes = (cards: AgentCard[]): Array<Exclude<RuntimeFilter, 'all'>> =>
  RUNTIME_ORDER.filter((runtime) =>
    cards.some((card) => card.tags.some((tag) => tag.label.toLowerCase().includes(runtime))),
  );

/** True when a card survives both the status and runtime filters. */
export const matchesFilters = (card: AgentCard, status: StatusFilter, runtime: RuntimeFilter): boolean => {
  if (status !== 'all' && cardStatus(card) !== status) {
    return false;
  }
  if (runtime !== 'all' && !card.tags.some((t) => t.label.toLowerCase().includes(runtime))) {
    return false;
  }
  return true;
};

/** Filters cards per section and drops sections left with nothing to show. */
export const filterGroups = <G extends { cards: AgentCard[] }>(
  groups: G[],
  status: StatusFilter,
  runtime: RuntimeFilter,
): G[] => {
  const active = status !== 'all' || runtime !== 'all';
  return groups
    .map((group) => ({ ...group, cards: group.cards.filter((c) => matchesFilters(c, status, runtime)) }))
    .filter((group) => !active || group.cards.length > 0);
};
